import { render, staticRenderFns } from "./view_forgot_popup.vue?vue&type=template&id=30985964&scoped=true&"
import script from "./view_forgot_popup.vue?vue&type=script&lang=js&"
export * from "./view_forgot_popup.vue?vue&type=script&lang=js&"
import style0 from "./view_forgot_popup.vue?vue&type=style&index=0&id=30985964&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30985964",
  null
  
)

export default component.exports